'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConfirmMail = undefined;

var _ConfirmMail2 = require('./ConfirmMail');

var _ConfirmMail3 = _interopRequireDefault(_ConfirmMail2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ConfirmMail = _ConfirmMail3.default;


//////////////////
// WEBPACK FOOTER
// ./src/components/ConfirmMail/index.js
// module id = 1648
// module chunks = 0